/**
 * Nina's Waffles — Theme JS
 * Minimal vanilla JS for mobile nav toggle and smooth interactions.
 */

document.addEventListener('DOMContentLoaded', function() {
  // Cart count update on page load
  const cartCount = document.getElementById('CartCount');
  if (cartCount && cartCount.textContent === '0') {
    cartCount.style.display = 'none';
  }
});
